import axios from 'axios';
import http from './http.api';

export const getOpportunityCertificateSummary = async (
    opportunityId: string,
    recordType: string
  ) => {
    try {
      const url = `/v1/SummaryReport/summaryReport/opportunitycertificate?OpportunityId=${encodeURIComponent(opportunityId)}&RecordType=${encodeURIComponent(recordType)}`;
      const response = await http.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching summary report:', error);
      throw error;
    }
  };

  
  export const createSummaryReport = async (reportData: any) => {
    try {
      const url = `/v1/SummaryReport/summaryReport/create`;
      const response = await http.post(url, reportData);
      return response.data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data || error.message);
      }
      throw new Error('Unknown create summary report error');
    }
  };
  

  export const editSummaryReport = async (reportID:any,reportData: any) => {
    try {
      const url = `/v1/SummaryReport/summaryReport/${reportID}`;
      const response = await http.put(url, reportData);
      return response.data;
    } catch (error) {
      console.error('Error creating summary report:', error);
      throw error;
    }
  };


  export const postSummarymessages = async (requestData: object) => {
    try {
      const url = `/v1/Messaging`;
      const response = await http.post(url, requestData);
      return response.data;
    } catch (error) {
      console.error('Error creating message:', error);
      throw error;
    }
  };

  export const getSummarymessages = async (SummaryReportId: string) => {
    try {
      const url = `/v1/Messaging/loggedinuser/messages?SummaryReportId=${SummaryReportId}`;
      const response = await http.get(url);
      return response.data;
    } catch (error) {
      console.error('Error getting message:', error);
      throw error;
    }
  };

  export const getSummaryreport = async (SummaryReportId: string) => {
    try {
      const url = `/v1/SummaryReport/summaryReport/${SummaryReportId}`;
      const response = await http.get(url);
      return response.data;
    } catch (error) {
      console.error('Error getting message:', error);
      throw error;
    }
  };


  export const getSection_3_4 = async (
    OpportunityId: string,
    RecordType: string
  ) => {
    try {
      const url = `/v1/SummaryReport/summaryReport/opportunitycertificate?OpportunityId=${OpportunityId}&RecordType=${RecordType}`;
      const response = await http.get(url);
      return response.data;
    } catch (error) {
      console.error("Error getting section 3/4:", error);
      throw error;
    }
  };
  